var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"copy-text",class:{copied: _vm.copied},on:{"click":_vm.click,"mouseleave":function($event){_vm.copied = false}}},[_c('span',{staticClass:"copy-text-inner"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"tooltip"},[_vm._v(" "+_vm._s(_vm.copied ? `${_vm._('copied')} ✓` : _vm._('copy'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }